import { ON_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function useFlexibleCampaignsUI() {
  const { ppx_flexible_campaigns_ui_web } = useExperiments([
    'ppx_flexible_campaigns_ui_web',
  ]);

  return ppx_flexible_campaigns_ui_web === ON_IDENTIFIER;
}
